/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_ExitInputs */

const en_cook_exit = /** @type {(inputs: Cook_ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit cooking mode`)
};

const de_cook_exit = /** @type {(inputs: Cook_ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochmodus beenden`)
};

/**
* | output |
* | --- |
* | "Exit cooking mode" |
*
* @param {Cook_ExitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_exit = /** @type {((inputs?: Cook_ExitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_ExitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_exit(inputs)
	return en_cook_exit(inputs)
});